import React, { useCallback, useEffect, useLayoutEffect, useRef, useState, } from 'react';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { TAB_SCREEN_HEADER_HEIGHT } from 'navigators/styles';
import { selectHasSetBudget } from 'reducers/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { Indicator } from 'design-system';
import { useFocusEffect } from 'hooks';
import { getIncomes } from 'actions';
import BudgetingTabHeader from './BudgetingTabHeader';
import { BudgetingScreenContent } from './BudgetingScreen';
import { SetUpBudgetScreenContent } from './SetUpBudgetScreen';
import { isWeb } from '../../../constants';
import { selectMonthlyTotalsWithBudgets } from '../selectors';
import { getBudgets } from '../actions';
const BudgetingTab = withAnimatedNavigationHeader((props) => {
    const { navigation } = props;
    const hasFeedThisMonth = useAppSelector((store) => !!store.feed.feed.cards.thisMonth);
    const hasSetBudget = useAppSelector(selectHasSetBudget);
    const isFetchingBudgets = useAppSelector((store) => store.budgeting.isFetchingBudgets);
    const filteredTotals = useAppSelector(selectMonthlyTotalsWithBudgets);
    const isLoaded = useRef(false);
    const [initialLoading, setInitialLoading] = useState(true);
    useEffect(() => {
        if (isWeb && isFetchingBudgets) {
            isLoaded.current = true;
            setInitialLoading(false);
        }
    }, [isFetchingBudgets]);
    const dispatch = useAppDispatch();
    useFocusEffect(useCallback(() => {
        dispatch(getBudgets());
        dispatch(getIncomes());
    }, []));
    const isLoading = isWeb &&
        ((initialLoading && !isLoaded.current) ||
            (isFetchingBudgets && !filteredTotals.length && !hasFeedThisMonth) ||
            !hasFeedThisMonth);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: isLoading || !hasSetBudget ? '' : 'Budgeting',
        });
    }, [hasSetBudget, isLoading]);
    if (isLoading) {
        return <Indicator dark/>;
    }
    if (!hasSetBudget) {
        return <SetUpBudgetScreenContent {...props}/>;
    }
    return <BudgetingScreenContent {...props}/>;
}, ({ colors }) => ({
    title: 'Budgeting',
    hasCustomTitle: true,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
    ...(!isWeb && {
        headerHeight: TAB_SCREEN_HEADER_HEIGHT,
        renderContent: () => <BudgetingTabHeader />,
    }),
}));
export default BudgetingTab;
